import styled from '@emotion/styled';
import { Typography } from '@material-ui/core';
import { ClassAttributes, createElement } from 'react';
import { FormattedMessage } from 'react-intl';

import { DynamicSchemaDefinitionField } from '../../../../../generated/graphql';
import Base from './Base';

interface Props {
  field: DynamicSchemaDefinitionField;
  className?: string;
}

const AsEmpty = ({ field, className }: Props & ClassAttributes<HTMLElement>) => {
  return (
    <Base field={field} className={className}>
      <Value>
        <FormattedMessage
          id={field.type === 'FILES' ? 'creative_brief_detail.field.files.empty' : 'creative_brief_detail.field.empty'}
        />
      </Value>
    </Base>
  );
};

const Value = styled(Typography)({
  wordBreak: 'break-word' as any,
  hyphens: 'auto',
});

export default AsEmpty;
